<template>
  <div>
    <search-list
      :buildInfoList="projectList"
      :stockRentTypeEnums="stockRentTypeEnums"
      :stockStatusEnums="stockStatusEnums"
      :stockIsShowEnums="stockIsShowEnums"
      :cooperationModeEnums="cooperationModeEnums"
      :stockIsUnderEnums="stockIsUnderEnums"
      @findData="findData"></search-list>
    <div class="page-wrapper">
      <table-list
        :columns="columns"
        :data="tableData"
        :total="total"
        :current="current"
        :loading="loading"
        @change-page="changePage"
        @on-selection-change="selectItem"
      >
        <Button v-p="{api:['houseInfo/batchImport','houseInfo/template/download']}" type="primary" class="btn" @click="importRoom">批量导入房间</Button>
        <Button v-p="{api:'houseInfo/batchAboveOrUnder'}"  type="primary" class="btn" @click="handleUnder">批量上/下架</Button>
        <Button v-p="{api:'houseInfo/addHouse'}"  type="primary" class="btn" @click="createdStock">添加房源</Button>
        <Button type="primary" v-p="{api:'houseInfo/batchModifyDiscountPrice'}" class="btn" @click="batchModifyPrice">批量调价</Button>
        <Button type="primary" v-p="{api:'batchLabel/saveOrEdit'}" class="btn" @click="setLabels">批量配置房间标签</Button>
      </table-list>
    </div>

    <batch-modify-price :n="modifyN"></batch-modify-price>
    <batch-import-modal :n="importKey"  @done="find(searched || searchData)"></batch-import-modal>
    <add-modal :n ="addKey" :stockStatusEnums ="stockStatusEnums" :projectList = "projectList" :projectOwnerList="projectOwnerList" @refresh="initTableData(searchData)"></add-modal>
    <update-modal :n ="updateKey" :projectList = "projectList" :projectOwnerList="projectOwnerList"  :stockFid="updateStockFid" @refresh="initTableData(searchData)"></update-modal >
    <lock-modal :n ="lockKey" :projectFid="projectFid" :stockFid="stockFid" :lockType="lockType" @refresh="initTableData(searchData)"></lock-modal>
    <show-modal :n ="showKey" :stockFid="stockFid" :showType="isShow"  @refresh="initTableData(searchData)"></show-modal>
    <delete-room-modal :n ="deleteKey" :stockFid="stockFid" @refresh="initTableData(searchData)"></delete-room-modal>
    <batch-above-or-under-modal :isBatch="true" @refresh="initTableData(searchData)" :n="handleUnderKey" :stockFidList = "stockFidList" :handleType="stockIsUnder"></batch-above-or-under-modal>
    <air-quality-report-modal :n="uploadKey" :moduleFid="stockFid" @show-img="showImg"></air-quality-report-modal>
    <intellect-detail :n="intellectDetailKey" :projectFid="projectFid" :stockParentFid="stockParentFid" :stockFid="stockFid" :stockNumber="stockNumber"></intellect-detail>
    <img-show :n="showImgKey" :src="imgUrl"></img-show>
    <set-labels :n="labelsN" :selection="selection" @refresh="initTableData(searchData)"></set-labels>
    <edit-labels :n="editLabelsN" :stockFid="stockFid"></edit-labels>
  </div>

</template>

<script type="text/ecmascript-6">
  import batchModifyPrice from './components/batchModifyPrice.vue'
  import SetLabels from './components/SetLabels'
  import EditLabels from './components/EditLabels'
  import { houseInfoList, getCondition,buildInfo } from "api/house"
  import { addCondition } from "api/project"
  import { formatMoney } from '@/utils/format'
  import SearchList from "./components/SearchList";
  import TableList from 'components/TableList/index';
  import BatchImportModal from './components/BatchImportModal';
  import IntellectDetail from './components/IntellectDetail';
  import AddModal from './components/AddModal';
  import UpdateModal from './components/UpdateModal';
  import LockModal from './components/LockModal';
  import ShowModal from './components/ShowModal';
  import SubStock from './components/SubStock';
  import DeleteRoomModal from './components/DeleteRoomModal';
  import BatchAboveOrUnderModal from './components/BatchAboveOrUnder';
  import AirQualityReportModal from './components/AirQualityReportModal';
  import ImgShow from 'components/ImgShow/index'


  export default {
    name:'inventory',
    created(){
      if(this.$route.params.projectFid){
        this.searchData.projectFid = this.$route.params.projectFid
      }
      this.initCondition().then(res => {
        this.searchData.projectCooperationModel = res[0].value;
        this.initTableData(this.searchData)
      })
    },

    data() {
      return {
        editLabelsN:0,
        labelsN:0,
        searched:null,
        modifyN:0,
        total:0,
        current : 1,
        loading:false,
        addKey:0,
        updateKey:0,
        lockKey:0,
        showImgKey:0,
        imgUrl:'',
        lockType:0, // 锁定状态类型，0为解锁 2为锁定操作
        isShow:0, // 0为隐藏操作 1为显示操作
        showKey:0,
        deleteKey:0,
        handleUnderKey:0,
        uploadKey:0,
        intellectDetailKey:0,
        stockFid:'',
        projectFid: '',
        stockParentFid:'',
        // projectFid:'',
        stockNumber:'',
        updateStockFid:'',
        stockRentTypeEnums:[],
        stockStatusEnums:[],
        stockIsShowEnums:[],
        cooperationModeEnums:[],
        stockIsUnderEnums:[],
        projectList:[],
        projectOwnerList:[],
        stockIsUnder:0, // 已上架状态
        stockFidList:'',
        searchData:{
          projectCooperationModel:0,
          projectFid: '',
          houseBuildingFid: '',
          houseFloorNumber: '',
          houseTypeFid: '',
          stockStatus: '',
          stockRentType: '',
          stockIsUnder: '',
          stockIsShow: '',
          minStockArea: '',
          maxStockArea:'',
          stockNumber: '',
          limit: 10,
          page: 1
        },
        selection:[],
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            type: 'expand',
            width: 50,
            render: (h, params) => {
              return h(SubStock, {
                props: {
                  stockFid: params.row.fid
                }
              })
            }
          },
          {
            title:' '
          },
          {
            title: '房间号',
            width:100,
            key: 'stockNumber',
            align: 'center',
            render: (h,params)=>{
              return h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'outHouse/houseDetail'

                    }
                  }
                ],

                on:{
                  click: () => {
                    const stockFid = params.row.fid;
                    if(params.row.stockRentType === 0){
                      this.$router.push({ name: 'housedetail', params: {stockFid:stockFid }})
                    }
                  }
                }
              },params.row.stockNumber)
            }
          },
          {
            title:' '
          },
          {
            title: '项目名称',
            width:200,
            key: 'projectName',
            align: 'center',
            render: (h,params)=>{
              return h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'project/getBaseInfoByProjectId'
                    }
                  }
                ],
                on:{
                  click: () => {
                    const projectFid = params.row.projectFid;
                    this.$router.push({ name: 'projectinfo', params: { id: projectFid }})
                  }
                }
              },params.row.projectName)
            }
          },
          {
            title:' '
          },
          {
            title: '房型名称',
            width: 180,
            key: 'houseTypeName',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '楼栋',
            width: 100,
            key: 'buildingName',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '楼层',
            width: 60,
            key: 'houseFloorNumber',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '出租类型',
            width: 100,
            key: 'stockRentTypeCn',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '风格',
            width: 100,
            key: 'stockDecorationstyleCn',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '房源状态',
            width: 100,
            key: 'stockStatusCn',
            align: 'center',
            render:(h,params)=> {
              const str = params.row.stockRentType === 0 ? params.row.stockStatusCn :'';
              return h('div',str)
            }
          },
          {
            title:' '
          },
          {
            title: '面积',
            minWidth:60,
            width: 60,
            key: 'stockArea',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '朝向',
            key: 'stockDirectionCn',
            width:100,
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '出租价格',
            width: 100,
            key: 'stockRentPrice',
            align: 'center',
            render: (h,params) => {
              return h('div',{
                style:{
                  'text-align' :'right'
                }

              },formatMoney(params.row.stockRentPrice))
            }
          },
          {
            title:' '
          },
          {
            title: '优惠价',
            width: 100,
            key: 'discountPrice',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '优惠价有效期',
            width: 100,
            key: 'discountPriceTime',
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '是否上架',
            width: 100,
            key: 'stockIsUnderCn',
            align: 'center'
          },
          {
            title:'状态',
            width: 100,
            key: 'stockIsShowCn',
            align: 'center'
          },
          {
            title: '空气检测报告',
            width: 110,
            key: 'airQualityReport',
            align: 'center',
            render:(h,params) => {
              return h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'label/getConfigImg'
                    }
                  }
                ],
                on:{
                  click: () => {
                    this.stockFid = params.row.fid;
                    this.uploadKey++
                  }
                }
              },'配置')
            }
          },
          {
            title:' '
          },
          {
            title: '房间标签',
            width: 110,
            align: 'center',
            render:(h,params) => {
              return h('a',{
                style: {
                  marginRight: '5px',
                  display: params.row.stockRentType === 1 ? 'none' : 'inline-bock'
                },
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'batchLabel/saveOrEdit'
                    }
                  }
                ],
                on:{
                  click: () => {
                    this.stockFid = params.row.fid;
                    this.editLabelsN++
                  }
                }
              },'配置')
            }
          },
          {
            title:' '
          },
          {
            title: '智能设备',
            width: 110,
            key: 'fid',
            align: 'center',
            render:(h,params) => {
              return h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'increase/intellectDetail'
                    }
                  }
                ],
                on:{
                  click: () => {
                    this.stockFid = params.row.fid
                    this.stockParentFid = params.row.stockParentFid
                    this.projectFid = params.row.projectFid
                    this.stockNumber = params.row.stockNumber
                    this.intellectDetailKey++
                  }
                }
              },'配置')
            }
          },
          {
            title:' '
          },
          {
            title:'操作',
            key:'action',
            width:220,
            // fixed: 'right',
            align:'center',
            render:(h,params) => {
              return h('div',[h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'houseInfo/updateHouse'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display:params.row.roomStatus===1 ? 'none':'inline-block'
                },
                on:{
                  click: () => {
                    this.updateKey++;
                    this.updateStockFid = params.row.fid
                  }
                }
              },'修改'),h('a',{
                directives: [
                  {
                    name: 'p',
                    value: {
                      api:'houseInfo/lockStock'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.stockRentType === 1 || params.row.stockStatus === 1 ? 'none' :'inline-block'
                },
                on:{
                  click: () => {
                    // 0：待租中 1：已出租 2:锁定 3:配置中
                    if(params.row.stockStatus == 2){
                      //解锁
                      this.lockType = 0
                    } else {
                      // 锁定
                      this.lockType = 2;
                    }
                    this.projectFid = params.row.projectFid;
                    this.stockFid = params.row.fid;
                    this.lockKey++
                  }
                }
              }, params.row.stockStatus == 2 ? '解锁' : '锁定'),
                h('a',{
                  directives: [
                    {
                      name: 'p',
                      value: {
                        api:'houseInfo/showOrHideHouse'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px',
                    display: params.row.stockRentType === 1?'none' :'inline-block'
                  },
                  on:{
                    click: () => {
                      this.isShow = params.row.stockIsShow===0 ? 1:0;
                      this.stockFid = params.row.fid;
                      this.showKey++
                    }
                  }
                },params.row.stockIsShow==0? '显示':'隐藏'),
                h('a',{
                  directives: [
                    {
                      name: 'p',
                      value: {
                        api:'houseInfo/delete'
                      }
                    }
                  ],
                  'class':{
                    'delele-btn':true
                  },
                  style:{
                    display:params.row.stockStatus === 1 ? 'none' : 'inline-blcok'
                  },
                  // props: {
                  // 	type:'error',
                  //   size:'small',
                  //   disabled:params.row.stockStatus === 1
                  // },
                  on:{
                    click: () => {
                      this.stockFid = params.row.fid;
                      this.deleteKey++
                    }
                  }
                },'删除')])
            }
          },
        ],
        tableData: [],
        importKey:0,
      };
    },
    components: {
      batchModifyPrice,
      SearchList,
      TableList,
      IntellectDetail,
      BatchImportModal,
      AddModal,
      UpdateModal,
      LockModal,
      ShowModal,
      DeleteRoomModal,
      BatchAboveOrUnderModal,
      AirQualityReportModal,
      ImgShow,
      SetLabels,
      EditLabels,
    },
    methods: {
      batchModifyPrice(){
        this.modifyN++
      },
      setLabels(){
        if(this.selection.length === 0) {
          this.$Message.info('请选择要操作的房源！')
          return false
        }
        const hezu = this.selection.filter(ele => {
          return ele.stockRentType === 1
        })
        if(hezu.length > 0){
          this.$Message.info('合租房不支持批量添加标签，请在列表-房间标签列单独为合租房添加标签')
          return false
        }
        this.labelsN++
      },
      findData(searchData) {
        this.loading = true;
        this.current = 1;
        this.searchData = searchData;
        this.searchData.page = 1;
        this.initTableData(searchData)
      },
      changePage(n){
        this.loading  = true;
        this.current = n;
        this.searchData.page = n;
        this.initTableData(this.searchData)
      },
      importRoom(){
        this.importKey++
      },
      initCondition (){
        buildInfo().then ( res=> {
          this.projectList = res.data
        });
        addCondition().then( res => {
          this.projectOwnerList = res.data.projectOwner
        });

        return new Promise((resolve) => {
          getCondition().then( res => {
            this.stockRentTypeEnums = res.data.stockRentTypeEnums;
            this.stockStatusEnums = res.data.stockStatusEnums;
            this.stockIsShowEnums = res.data.stockIsShowEnums;
            this.cooperationModeEnums = res.data.cooperationModeEnums;
            this.stockIsUnderEnums = res.data.stockIsUnderEnums;
            resolve(res.data.cooperationModeEnums)
          })
        })
      },
      initTableData(params){
        houseInfoList(params).then(res => {
          this.tableData = res.data.rows;
          this.tableData.forEach(item => {
            if(item.stockRentType === 0){
              item._disableExpand = true
            }
          });
          this.total = res.data.total;
          this.loading = false
          this.searched=params


        })
      },

      changeShow(value) {
        this.show = value
      },
      createdStock(){
        this.addKey++
      },
      handleUnder(){
        if(this.selection.length < 1) {
          this.$Message.info('请选择要操作的房源！')
        }else {
          const stockIsUnder = this.selection[0].stockIsUnder;
          const temArr = this.selection.filter( (item) => {
            return item.stockIsUnder !== stockIsUnder
          });
          if(temArr.length > 0) {
            this.$Message.info('房源是否上架状态不一致！');
          } else {
            this.stockIsUnder = stockIsUnder === 0 ? 1 :0;
            this.stockFidList = this.selection.map( item => {
              return item.fid
            }).join();
            this.handleUnderKey++
          }
        }
      },
      selectItem(selection){
        this.selection = selection
      },
      showImg(img){
        this.imgUrl = img;
        this.showImgKey++
      }
    }
  };
</script>

<style lang="css" scoped>
  .btn {
    margin-bottom: 20px;
  }
</style>
